export default __webpack_public_path__ + "dd04000f745c86c8bb74e10ead920bf1.svg";